import React from 'react'
import { useSelector } from 'react-redux'
import Popup from 'src/components/Popup/Popup'
import { selectAlertMessageFromState } from 'src/redux/selectors/app.selectors'
import { css } from 'styled-components'

interface SystemAlertPopupProps {
  onClose: () => void
}

const SystemAlertPopup: React.FC<SystemAlertPopupProps> = (
  props,
): React.ReactElement => {
  const alertMessage = useSelector(selectAlertMessageFromState)

  return (
    <Popup
      onClose={props.onClose}
      css={css`
        display: flex;
        flex-direction: column;
      `}
    >
      <p>{alertMessage}</p>
    </Popup>
  )
}

export default SystemAlertPopup
